module.exports = __webpack_public_path__ + "img/9_windAndRain_gm.7a352a65.png";